module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/man-icon-94d296c50c5d37e853c1249b10fca1aa.png";